import { useDispatch } from "react-redux";
import {
  deleteCartItem,
  updateCartItemQunatity,
} from "../../../../store/features/Cart/actionCreator";
import {
  decreaseByOne,
  increaseByOne,
  increaseByQuantity,
} from "../../../../store/features/Product/actionCreator";

export default function CartItem({ item }) {
  const dispatch = useDispatch();
  const { name, image, category, price, cartQuantity, quantity, id } = item;

  const handleQuantityChange = (type) => {
    // if the quantity is 1 and the user clicks on the minus button, return or if the is equal to stock quantity and the user clicks on the plus button, return
    if (
      (cartQuantity === 1 && type === "-") ||
      (cartQuantity === Number(quantity) && type === "+")
    ) {
      return;
    }

    dispatch(updateCartItemQunatity(id, type));

    // if the user deletes the item from the cart, update the stock quantity
    if (type === "-") {
      dispatch(increaseByOne(id));
    } else if (type === "+") {
      dispatch(decreaseByOne(id));
    }
  };

  const handleDelete = () => {
    dispatch(deleteCartItem(id));
    dispatch(increaseByQuantity(id, quantity));
  };

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        {/* cart image */}
        <img className="lws-cartImage" src={image} alt="product" />
        {/* cart item info */}
        <div className="space-y-2">
          <h4 className="lws-cartName">{name}</h4>
          <p className="lws-cartCategory">{category}</p>
          <p>
            BDT <span className="lws-cartPrice">{price}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        {/* amount buttons */}
        <div className="flex items-center space-x-4">
          <button
            className="lws-incrementQuantity"
            onClick={() => handleQuantityChange("+")}
          >
            <i className="text-lg fa-solid fa-plus" />
          </button>
          <span className="lws-cartQuantity">{cartQuantity}</span>
          <button
            className="lws-decrementQuantity"
            onClick={() => handleQuantityChange("-")}
          >
            <i className="text-lg fa-solid fa-minus" />
          </button>
        </div>
        {/* price */}
        <p className="text-lg font-bold">
          BDT{" "}
          <span className="lws-calculatedPrice">
            {Number(price) * Number(cartQuantity)}
          </span>
        </p>
      </div>
      {/* delete button */}
      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button className="lws-removeFromCart" onClick={handleDelete}>
          <i className="text-lg text-red-400 fa-solid fa-trash" />
        </button>
      </div>
    </div>
  );
}
